import React from 'react';
import Seo from '../components/Seo';
import { apps } from '../data/apps';

function Home() {
  return (
    <section className="App-home">
      <Seo
        title="Dreamcode — Mobile apps and games"
        description="Dreamcode builds useful mobile apps and games — NumGen Pro, SG Bus & MRT, Rain Radar & Alerts, Snack Snake, and PDF Desk. Tools and games, built with care."
        path="/"
      />
      <div className="App-home-intro">
        <h1>Apps, tools, and games by Dreamcode.</h1>
        <p>
          Useful mobile apps and games — Singapore bus and MRT arrivals, live rain radar, number
          tools, arcade games, and free PDF editing in the browser.
        </p>
      </div>
      <ul className="App-grid">
        {apps.map((app) => (
          <li key={app.id} className="App-grid-item">
            <div className="App-grid-card">
              <img src={app.icon} alt={`${app.name} icon`} className="App-grid-icon" />
              <div className="App-grid-text">
                <h2>{app.name}</h2>
                <p>{app.description}</p>
                {app.comingSoon ? (
                  <span className="App-grid-badge">Coming soon</span>
                ) : (
                  <div className="App-grid-stores">
                    {app.playStoreUrl && (
                      <a
                        href={app.playStoreUrl}
                        className="App-store-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Play
                      </a>
                    )}
                    {app.appStoreUrl && (
                      <a
                        href={app.appStoreUrl}
                        className="App-store-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        App Store
                      </a>
                    )}
                    {app.websiteUrl && (
                      <a
                        href={app.websiteUrl}
                        className="App-store-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open website
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Home;
